import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import InputWrapper from 'shared/components/InputWrapper'
import resImportDevices from './resolvers/resImportDevices'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'
import getBrandContent from 'utils/getBrandContent'
import downloadTemplate from './utils/downloadTemplate'
import { download } from 'ionicons/icons'
import { IonIcon } from '@ionic/react'

const submitRef = React.createRef<HTMLButtonElement>()

const ImportDevices: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resImportDevices,
  })

  useInit({
    getValues,
    reset,
    setDataLoaded,
    setShowOverlay,
    currentCustomer,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={<BackButton url='/' text='Devices' />}
      actionInsert={
        <>
          <Button
            onClick={(e) => {
              e.preventDefault()
              downloadTemplate({
                setShowOverlay,
              })
            }}
            variant='primary'
            className='me-3'
          >
            <IonIcon
              icon={download}
              className='ionicon'
              style={{ fontSize: '16px', marginBottom: '-3px' }}
            />
            Download Import Template
          </Button>
          <Button
            disabled={!dataLoaded}
            type='submit'
            name='save'
            className='btn-round btn-primary'
            onClick={() => {
              if (submitRef.current != null) {
                submitRef.current.click()
              }
            }}
          >
            Import
          </Button>
        </>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError,
            id: undefined,
            name: 'Devices',
            successNav: '/',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='File' name='file' errors={errors}>
          <Form.Control type='file' {...register('file')} />
        </InputWrapper>

        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default ImportDevices
